// extracted by mini-css-extract-plugin
export default {"board":"Board_board__M1PtA","board__item":"Board_board__item__u7n7D"};